<template>
<b-container>
  <b-row>
    <b-col class="order-3" cols="12">
      <b-row>
	<b-col>
	  <div class=" py-2 bg-light">
	    <b-tabs>
	      <b-tab title="Manual Performance">
		<b-container>
		  <b-row>
		    <b-col cols="12" md="6" class="px-0">
		      <ProductsMetaChartManual class="bg-white" />
		    </b-col>
		    <b-col cols="12" md="6" class="px-0">
		      <ProductsMetaChartPercentage class="bg-white" />
		    </b-col>
		  </b-row>
		</b-container>
	      </b-tab>
	      <b-tab title="Trinity Performance">
		<ProductsMetaChartTvc class="bg-white" />
	      </b-tab>
	    </b-tabs>	    	      
	  </div>
	</b-col>
      </b-row>
      <b-row>
	<b-col>
	  <div class="px-2 px-sm-5 py-5 bg-white">
	    <div role="tablist">
	      <b-card no-body class="mb-1 border-0">
		<b-card-header header-tag="header" class="p-1" role="tab">
		  <b-button block v-b-toggle.method-accordion variant="light">
		    <h4 style="font-weight: 400; white-space: normal;">Click here for Reading Performance Method</h4>
		  </b-button>
		</b-card-header>
		<b-collapse id="method-accordion" accordion="method-accordion" role="tabpanel">
		  <div class="px-2 px-sm-5 pt-3">
		    <h3 class="mb-3" style="font-weight: 400;">Currently there are two major Construction and Engineering SaaS services that provide fully automated PDF metadata reading capability we tested against</h3>
		  </div>
		  <div class="px-2 px-sm-5 py-2 bg-light">
		    <h3 class="mb-3" style="font-weight: 400;">Using a varied set of 5 different drawing sets from actual construction projects:</h3>
		  </div>
		  <div class="px-2 px-sm-5 pb-3">
		    <h3 class="mb-3" style="font-weight: 400;"> Without any automation, it would take <span class="gmx-red">1,530 minutes, or 25.5 hours</span>, to type in the <span class="gmx-red">Number, Title and Discipline</span> of each sheet in the suite.  To also manually add all the <span class="gmx-red">links</span>, it would take another <span class="gmx-red">10,870 minutes or 181 hours</span> (22 working days)</h3>
		  </div>
		</b-collapse>
	      </b-card>
	    </div>
	    <b-container class="px-0">
	      <ProductsMetaTableHeader v-for="cell in headers" class="font-weight-bold">
		<span slot="row-title" class="header-text">{{ cell.rowTitle }}</span>
		<span slot="dealership" class="header-text">{{ cell.dealership }}</span>
		<span slot="stadium" class="header-text">{{ cell.stadium }}</span>
		<span slot="office" class="header-text">{{ cell.office }}</span>
		<span slot="highrise" class="header-text">{{ cell.highrise }}</span>
		<span slot="data-center" class="header-text">{{ cell.datacenter }}</span>
	      </ProductsMetaTableHeader>
	      <ProductsMetaTableRow v-for="cell in totalSheets">
		<span slot="row-title" class="row-text">{{ cell.rowTitle }}</span>
		<span slot="dealership" class="row-text">{{ cell.dealership }}</span>
		<span slot="stadium" class="row-text">{{ cell.stadium }}</span>
		<span slot="office" class="row-text">{{ cell.office }}</span>
		<span slot="highrise" class="row-text">{{ cell.highrise }}</span>
		<span slot="data-center" class="row-text">{{ cell.datacenter }}</span>
	      </ProductsMetaTableRow>
	    </b-container>
	    <div role="tablist">
	      <b-card no-body class="mb-1">
		<b-card-header header-tag="header" class="px-0" role="tab">
		  <b-button block href="#" v-b-toggle.accordion-1 variant="light" class="px-0">
		    <b-container>
		      <b-row>
			<b-col cols="12" lg="8" style="white-space: normal;">
			  <h5 style="font-weight: 400;">Performance with <span class="gmx-red" style="font-weight: 700;">Trinity</span> focus learning OCR integration</h5>
			</b-col>
			<b-col cols="12" lg="4" class="px-0">
			  <span class="gmx-red text-lg-right" style="font-weight: 700;">6955%</span> improvement over full manual
			</b-col>
		      </b-row>
		    </b-container>
		    <b-container class="bg-white">
		      <b-row>
			<b-col cols="3" class="border px-0 py-4 py-sm-2" style="white-space: normal;">
			  <div class="cell-div row-text"><span class="m-auto py-2">Manual Time Needed (minutes)</span></div>
			</b-col>
			<b-col cols="1" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>0</span></div>
			</b-col>
			<b-col cols="2" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>1</span></div>
			</b-col>
			<b-col cols="2" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>4</span></div>
			</b-col>
			<b-col cols="2" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>16</span></div>
			</b-col>
			<b-col cols="1" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>1</span></div>
			</b-col>
			<b-col cols="1" class="border px-0 py-4" style="background-color: #ff0000;">
			  <div class="cell-div row-text"><span class="text-light font-weight-bold">22 min</span></div>
			</b-col>
		      </b-row>
		    </b-container>
		  </b-button>
		</b-card-header>
		<b-collapse id="accordion-1" accordion="performance-accordion-1" role="tabpanel">
		  <b-card-body class="p-0">
		    <ProductsMetaTableRow v-for="cell in trinity">
		      <span slot="row-title" class="row-text">{{ cell.rowTitle }}</span>
		      <span slot="dealership" class="row-text">{{ cell.dealership }}</span>
		      <span slot="stadium" class="row-text">{{ cell.stadium }}</span>
		      <span slot="office" class="row-text">{{ cell.office }}</span>
		      <span slot="highrise" class="row-text">{{ cell.highrise }}</span>
		      <span slot="data-center" class="row-text">{{ cell.datacenter }}</span>
		    </ProductsMetaTableRow>
		    <div class="px-3 bg-light">
		      <div>
			<small>*Manual entry time assumptions: Titles 16 sec., Number 8 sec., Discipline 4 sec.</small>
		      </div>
		      <div>
			<small>*Test performed April 12 2020 using full automated process with no manual assist</small>
		      </div>
		    </div>
		  </b-card-body>
		</b-collapse>
	      </b-card>
	      <b-card no-body class="mb-1">
		<b-card-header header-tag="header" class="px-0" role="tab">
		  <b-button block href="#" v-b-toggle.accordion-2 variant="light" class="px-0">
		    <b-container>
		      <b-row>
			<b-col cols="12" lg="8">
			  <h5 style="font-weight: 400; white-space: normal;">Leading A Brand Reading Performance</h5>
			</b-col>
			<b-col cols="12" lg="4" class="px-0">
			  <span class="gmx-red text-lg-right" style="font-weight: 700;">188%</span> improvement over full manual
			</b-col>
		      </b-row>
		    </b-container>
		    <b-container class="bg-white">
		      <b-row class="text-center">
			<b-col cols="3" class="border px-0 py-4 py-sm-2" style="white-space: normal;">
			  <div class="cell-div row-text"><span>Manual Time Needed (minutes)</span></div>
			</b-col>
			<b-col cols="1" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>26</span></div>
			</b-col>
			<b-col cols="2" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>54</span></div>
			</b-col>
			<b-col cols="2" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>128</span></div>
			</b-col>
			<b-col cols="2" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>116</span></div>
			</b-col>
			<b-col cols="1" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>492</span></div>
			</b-col>
			<b-col cols="1" class="border px-0 py-4 py-sm-2"  style="background-color: #ff0000;">
			  <div class="cell-div row-text"><span class="text-light font-weight-bold">816 min</span></div>
			</b-col>
		      </b-row>
		    </b-container>
		  </b-button>
		</b-card-header>
		<b-collapse id="accordion-2" accordion="performance-accordion-2" role="tabpanel">
		  <ProductsMetaTableRow v-for="cell in leadingA">
		    <span slot="row-title" class="row-text">{{ cell.rowTitle }}</span>
		    <span slot="dealership" class="row-text">{{ cell.dealership }}</span>
		    <span slot="stadium" class="row-text">{{ cell.stadium }}</span>
		    <span slot="office" class="row-text">{{ cell.office }}</span>
		    <span slot="highrise" class="row-text">{{ cell.highrise }}</span>
		    <span slot="data-center" class="row-text">{{ cell.datacenter }}</span>
		  </ProductsMetaTableRow>
		  <div class="px-3 bg-light">
		    <div>
		      <small>*Manual entry time assumptions: Titles 16 sec., Number 8 sec., Discipline 4 sec.</small>
		    </div>
		    <div>
		      <small>*Test performed April 12 2020 using full automated process with no manual assist</small>
		    </div>
		    <h4 style="color: #ff0000;">Trinity saves 794 minutes (13.2 hours) or 3,709% of manual time over Brand A</h4>
		  </div>
		</b-collapse>
	      </b-card>
	      <b-card no-body class="mb-1">
		<b-card-header header-tag="header" class="px-0" role="tab">
		  <b-button block href="#" v-b-toggle.accordion-3 variant="light" class="px-0">
		    <b-container>
		      <b-row>
			<b-col cols="12" lg="8">
			  <h5 style="font-weight: 400; white-space: normal;">Leading B Brand Reading Performance</h5>
			</b-col>
			<b-col cols="12" lg="4" class="px-0">
			  <span class="gmx-red text-lg-right" style="font-weight: 700;">184%</span> improvement over full manual
			</b-col>
		      </b-row>
		    </b-container>
		    <b-container class="bg-white">
		      <b-row class="text-center">
			<b-col cols="3" class="border px-0 py-4 py-sm-2" style="white-space: normal;">
			  <div class="cell-div row-text"><span>Manual Time Needed (minutes)</span></div>
			</b-col>
			<b-col cols="1" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>14</span></div>
			</b-col>
			<b-col cols="2" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>30</span></div>
			</b-col>
			<b-col cols="2" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>101</span></div>
			</b-col>
			<b-col cols="2" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>282</span></div>
			</b-col>
			<b-col cols="1" class="border px-0 py-4 py-sm-2">
			  <div class="cell-div row-text"><span>404</span></div>
			</b-col>
			<b-col cols="1" class="border px-0 py-4 py-sm-2" style="background-color: #ff0000;">
			  <div class="cell-div row-text"><span class="text-light font-weight-bold">831 min</span></div>
			</b-col>
		      </b-row>
		    </b-container>
		  </b-button>
		</b-card-header>
		<b-collapse id="accordion-3" accordion="performance-accordion-3" role="tabpanel">
		  <ProductsMetaTableRow v-for="cell in leadingB">
		    <span slot="row-title" class="row-text">{{ cell.rowTitle }}</span>
		    <span slot="dealership" class="row-text">{{ cell.dealership }}</span>
		    <span slot="stadium" class="row-text">{{ cell.stadium }}</span>
		    <span slot="office" class="row-text">{{ cell.office }}</span>
		    <span slot="highrise" class="row-text">{{ cell.highrise }}</span>
		    <span slot="data-center" class="row-text">{{ cell.datacenter }}</span>
		  </ProductsMetaTableRow>
		  <div class="px-3 bg-light">
		    <div>
		      <small>*Manual entry time assumptions: Titles 16 sec., Number 8 sec., Discipline 4 sec.</small>
		    </div>
		    <div>
		      <small>*Test performed April 12 2020 using full automated process with no manual assist</small>
		    </div>
		    <h4 style="color: #ff0000;">Trinity saves 809 minutes (13.5 hours) or 3,777% of manual time over Brand B</h4>
		  </div>
		</b-collapse>
	      </b-card>
	    </div>	    
	  </div>
	</b-col>
      </b-row>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
// @ is an alias to /src
const $ = require('jquery')
import * as log from 'loglevel'
import ProductsTab from '@/components/products-tab.vue';
import ProductsMetaChartManual from '@/components/products-meta-chart-manual.vue';
import ProductsMetaChartPercentage from '@/components/products-meta-chart-percentage.vue';
import ProductsMetaChartTvc from '@/components/products-meta-chart-tvc.vue';
import ProductsMetaTableRow from '@/components/products-meta-table-row.vue';
import ProductsMetaTableHeader from '@/components/products-meta-table-header.vue';
export default {
    name: 'ManualVsTrinity',
    components: {
	ProductsTab,
	ProductsMetaChartManual,
	ProductsMetaChartPercentage,
	ProductsMetaChartTvc,
	ProductsMetaTableRow,
	ProductsMetaTableHeader
    },
    data () {
	return {
            headers: [
		{
		    rowTitle: '',
		    dealership: 'Dealership',
		    stadium: 'Stadium Expansion',
		    office: 'Mixed Use Office',
		    highrise: 'Mixed Use Highrise',
		    datacenter: 'Data Center'
		},
	    ],
	    totalSheets: [
		{
		    rowTitle: 'Total Sheets',
		    dealership: 88,
		    stadium: 177,
		    office: 428,
		    highrise: 962,
		    datacenter: 1622
		},
	    ],
	    trinity: [
		{
		    rowTitle: 'Sheet Numbers Missed',
		    dealership: 0,
		    stadium: 2,
		    office: 7,
		    highrise: 24,
		    datacenter: 3
		},
		{
		    rowTitle: 'Sheet Titles Missed',
		    dealership: 0,
		    stadium: 3,
		    office: 10,
		    highrise: 54,
		    datacenter: 2
		},
		{
		    rowTitle: 'Disciplines Missed',
		    dealership: 0,
		    stadium: 2,
		    office: 7,
		    highrise: 35,
		    datacenter: 3
		}
	    ],
	    leadingA: [
		{
		    rowTitle: 'Sheet Numbers Missed',
		    dealership: 12,
		    stadium: 34,
		    office: 81,
		    highrise: 82,
		    datacenter: 1405
		},
		{
		    rowTitle: 'Sheet Titles Missed',
		    dealership: 88,
		    stadium: 176,
		    office: 420,
		    highrise: 365,
		    datacenter: 791
		},
		{
		    rowTitle: 'Disciplines Missed',
		    dealership: 12,
		    stadium: 35,
		    office: 81,
		    highrise: 112,
		    datacenter: 1405
		}
	    ],
	    leadingB: [
		{
		    rowTitle: 'Sheet Numbers Missed',
		    dealership: 0,
		    stadium: 0,
		    office: 14,
		    highrise: 54,
		    datacenter: 104
		},
		{
		    rowTitle: 'Sheet Titles Missed',
		    dealership: 29,
		    stadium: 69,
		    office: 265,
		    highrise: 790,
		    datacenter: 1058
		},
		{
		    rowTitle: 'Disciplines Missed',
		    dealership: 88,
		    stadium: 177,
		    office: 428,
		    highrise: 962,
		    datacenter: 1622
		}
	    ]
        }	
    },
    methods: {
	img: function (image) {
	    require(image)
	}
    }
};
</script>

<style>
.gmx-purple {
  color: #2e145e;
}
.gmx-red {
  color: #ff0000;
}
.cover-background {
    background-image: url('../assets/toolkit_cover_background.png');
    background-repeat: no-repeat;
    background-size: cover;
}
.header-text {
    overflow-wrap: anywhere;
}
@media (max-width: 576px) {
    .header-text {
	overflow-wrap: normal;
	font-size: 0.72em;
	font-weight: 200;
    }
    .row-text {
	overflow-wrap: normal;
	font-size: 0.72em;
    }
    .cell-div {
	transform: rotateZ(-90deg);
    }
}
</style>
